'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $('.nav-tabs--hp a').on('shown.bs.tab', function (event) {
        var lazyUrl = $(event.target).attr('data-lazy-url');
        if (lazyUrl) {
            $(event.target).removeAttr('data-lazy-url');
            $(event.target).tab('show');
            $.ajax({
                url: lazyUrl
            }).done(function (data) {
                $($(event.target).attr('href')).html(data);
                (0, _carousels2.default)($($(event.target).attr('href') + ' [data-carousel]'));
                _initialize2.default.trigger($($(event.target).attr('href')));
            });
        }
    });

    // for link to tab
    var urlHash = document.location.hash,
        navTabs = $('.nav-tabs', this),
        tabContent = $('.tab-content', this),
        url = document.location.toString();

    if (navTabs.length === 0) return;

    if (url.match('#')) {
        navTabs.find('a[href="#' + url.split('#')[1] + '"]').tab('show');
    }

    navTabs.on('click', 'a', function (e) {
        e.preventDefault();
        $(this).tab('show');

        // Reinitialize carousel upon tab change (only once)
        if ($(".tab-pane.active > [data-carousel] > div.slick-list > div.slick-track", this).width() === 0) {
            var slickOptions = $(".tab-pane.active > [data-carousel]", this)[0].slick.options;
            $(".tab-pane.active > [data-carousel]", this).slick("unslick");
            $(".tab-pane.active > [data-carousel]", this).slick(slickOptions);
        }

        // update hash without write to history
        if (history.replaceState) history.replaceState(undefined, undefined, this.hash);
    });

    if (tabContent.find(urlHash).length === 0 && tabContent.find('.active').length === 0) {
        navTabs.find('li:first-child').addClass('active');
        tabContent.find('.tab-pane:first-child').addClass('active');
    }

    $('#moreAnotation', this).click(function (e) {
        e.preventDefault();

        $('a[href="#longAnnotation"]', this).tab('show');

        var anotationOffsetTop = $('#longAnnotation').offset().top;

        $('html, body').animate({
            scrollTop: anotationOffsetTop - 200
        }, 1000);
    });

    // for hp animation tab
    var hpTabs = $('.nav-tabs--hp', this);

    if (hpTabs.length) {}
};

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

var _carousels = require('./carousels');

var _carousels2 = _interopRequireDefault(_carousels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/tabs.js
// module id = 1083
// module chunks = 0